import { isDesktop } from 'react-device-detect';
import { Button } from './Button/Button';

export default function Certificate(props) {
	const { name, eduInfos, date } = props;

	return (
		<div className="certificate-wrap">
			<img src="/static/images/img-certificate-cover.png" className="cover-img" alt="" />
			<div className="certificate">
				<div>
					<h1>수료증</h1>
					<table>
						<tbody>
							<tr>
								<th>
									<div>
										<span>성</span>
										<span>명</span>
									</div>
								</th>
								<td>{name}</td>
							</tr>
							<tr>
								<th>
									<div>
										<span>교육</span>
										<span>과정</span>
									</div>
								</th>
								<td>{eduInfos[0]}</td>
							</tr>
							<tr>
								<th>
									<div>
										<span>교육</span>
										<span>기간</span>
									</div>
								</th>
								<td>{eduInfos[1]}</td>
							</tr>
							<tr>
								<th>
									<div>
										<span>교육</span>
										<span>기관</span>
									</div>
								</th>
								<td>{eduInfos[2]}</td>
							</tr>
						</tbody>
					</table>
					<div className="desc">
						<p>위 사람은 서울대학교병원</p>
						<p>기술사업화지원센터에서 실시한 상기 교육을</p>
						<p>수료하였으므로 이 증서를 드립니다.</p>
					</div>
					<div className="date">{date}</div>
				</div>
				<div className="bottom">
					<p>서울대학교병원</p>
					<p>기술사업화지원센터</p>
				</div>
			</div>
			{isDesktop && (
				<Button type="button" className="print" onClick={window.print}>
					출력하기
				</Button>
			)}
		</div>
	);
}
